module.exports = __webpack_public_path__ + "img/wardInfoYellow.c39bac86.svg";